/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S2_Li2Inputs */

const en_guide_what_is_json_s2_li2 = /** @type {(inputs: Guide_What_Is_Json_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Number</strong>: Integer or floating-point: <code>42</code>, <code>3.14</code>, <code>-17</code>`)
};

const ko_guide_what_is_json_s2_li2 = /** @type {(inputs: Guide_What_Is_Json_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Number</strong>: 정수 또는 부동소수점: <code>42</code>, <code>3.14</code>, <code>-17</code>`)
};

const ja_guide_what_is_json_s2_li2 = /** @type {(inputs: Guide_What_Is_Json_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>数値</strong>: 整数または浮動小数点：<code>42</code>、<code>3.14</code>、<code>-17</code>`)
};

/**
* | output |
* | --- |
* | "<strong>Number</strong>: Integer or floating-point: <code>42</code>, <code>3.14</code>, <code>-17</code>" |
*
* @param {Guide_What_Is_Json_S2_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s2_li2 = /** @type {((inputs?: Guide_What_Is_Json_S2_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S2_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s2_li2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s2_li2(inputs)
	return ja_guide_what_is_json_s2_li2(inputs)
});